import Vue from "vue";

import GamesForPrizesList from "./GamesForPrizesList.vue";

export function load() {
    const selector = "games-for-prizes";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(GamesForPrizesList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
